export const ROLODEX_CONTACTS_SEARCH_URL: string = 'api/v1/rolodex/contacts/search';
export const ROLODEX_CONTACT_URL: string = 'api/v1/rolodex/contacts/{contactId}';
